export default __webpack_public_path__ + "static/media/acv_isquemico_actualizacion2017.4c0e45da.pdf";